// extracted by mini-css-extract-plugin
export var cardContainer = "ScoreComparisonCard-module--card-container--2p-6q";
export var cardShadow = "ScoreComparisonCard-module--card-shadow--n8wop";
export var cardContentContainer = "ScoreComparisonCard-module--card-content-container--dqmxB";